import { EdgeListHuntOptionsRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { ListHuntOptions } from '@/shared/domain/use-cases'

export function makeListHuntOptions(): ListHuntOptions {
  return new EdgeListHuntOptionsRepository(makeSupabaseEdgeHttpClient()).execute
}
